import React from 'react';
import { ListItemButton, styled, Typography } from '@mui/material';
import { Doctor } from 'types/doctor';

const ListItemStyled = styled(ListItemButton)({
  alignItems: 'center',
  gap: 10,
  justifyContent: 'flex-start',
  '& svg': {
    color: '#ccc',
  },
});

interface DoctorItemProps {
  option: Doctor;
  selected: Doctor | null;
  handleSelect(doctor: Doctor): void;
}

const DoctorItem: React.FC<DoctorItemProps> = ({ option, selected, handleSelect }) => {
  return (
    <ListItemStyled disabled={selected?.id === option.id} onClick={() => handleSelect(option)}>
      <div>
        <Typography>
          #{option.id} - {option.name}
        </Typography>
      </div>
    </ListItemStyled>
  );
};

export default DoctorItem;
